import getSession from '../../_graphql/queries/get-session.graphql';

export default {
  name: 'welcome',
  path: '/',
  loadComponent: () => import('./index'),
  graphqlPrefetch: () => [{ query: getSession }]
};
